export default (vehicle?: Vehicle | VehicleSearchResult | number) => {
  if (!vehicle || typeof vehicle === 'number') {
    return '<No vehicle recorded>';
  }

  let formattedVehicle = '';
  if (vehicle.year) {
    formattedVehicle += `${vehicle.year ?? ''} `;
  }

  if (vehicle.color) {
    formattedVehicle += `${vehicle.color ?? ''} `;
  }

  if (vehicle.make) {
    formattedVehicle += `${vehicle.make ?? ''} `;
  }

  if (vehicle.model) {
    formattedVehicle += `${vehicle.model ?? ''} `;
  }

  if (formattedVehicle === '') {
    formattedVehicle = '<Vehicle description missing>';
  }
  // Return a formatted vehicle description like:
  // 2002 Blue Honda Odyssey
  return formattedVehicle;
};
